import React from 'react';
import {Provider} from "react-redux";
import IntroContainer from "./container/IntroContainer";
import configure from '../../store/configure';
import Layout from "../../component/layout/Layout";
import "./style/global.css";

const IntroPage = () => {
    const searchParams = new URLSearchParams(window.location.search);

    // 포털 사이트 광고 통한 유입 여부 확인 파라미터
    let adSrc = searchParams.get("ad_src");
    return (
        <Provider store={configure}>
            <Layout>
                <IntroContainer adSrc={adSrc}/>
            </Layout>
        </Provider>
    );
};

export default IntroPage;
